"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http = require("./xhr");
var constants_1 = require("./constants");
exports.token = {
    isFetching: false,
    url: null,
    headers: {},
    init: function (_a) {
        var url = _a.url, headers = _a.headers;
        this.url = url;
        this.headers = headers;
    },
    destroy: function () {
        this.url = null;
        this.headers = {};
        this.isFetching = false;
    },
    get: function () {
        var _this = this;
        this.isFetching = true;
        return http
            .get(this.url, { headers: this.headers, withCredentials: true })
            .then(function (data) {
            _this.isFetching = false;
            return data.token;
        })
            .catch(function (error) {
            _this.isFetching = false;
            return Promise.reject(constants_1.ERROR_MESSAGES.GET_TOKEN_FAILED);
        });
    },
};
//# sourceMappingURL=token.js.map